
import styles from './QuoteDetailsPanel.module.css';
export default function QuoteDetailsFooter(props) {

    return (<div className={styles.QuoteDetailsFooter} componentname='QuoteDetailsFooter'>
        <div style={{ alignSelf: 'center' }} className='Font-Sm Text-Dark'>
            *The fees described in this quote are based on the information provided on your request, assumptions as noted previously and are valid for 90 days from date of issuance.
        </div>
    </div>)
}